// Project paths
export const projectsPath = '/accounts/:accountId/projects'
export const projectSettingsPath = '/accounts/:accountId/projects/:projectId'
export const projectContentPath =
  '/accounts/:accountId/projects/:projectId/content'
export const projectNodesPath = '/accounts/:accountId/projects/:projectId/nodes'
export const createProjectPath = '/accounts/:accountId/projects/create'

// Brand voice paths
export const brandVoicePath = '/admin/accounts/:accountId/brand-voice'
export const toneOfVoicePath =
  '/admin/accounts/:accountId/brand-voice/:brandVoiceId/tone-of-voice'
export const styleGuidePath =
  '/admin/accounts/:accountId/brand-voice/:brandVoiceId/style-guide'

export const dataSourcesPath = '/admin/accounts/:accountId/data-sources'

export const personalizationPerIdPath = '/personalization/:id'

export const integrationSettingsPath = '/admin/accounts/:accountId/integrations'

export const revenueSettingsPath =
  '/admin/accounts/:accountId/revenue-reporting'

export const accountsTokensPaths = '/admin/accounts/:accountId/api-tokens'

export const regionSettingsPath = '/admin/language/region'
export const nodesPath = '/admin/language/nodes'
export const campaignsPath = '/accounts/:accountId/campaigns'

export const selectedCampaignPath =
  '/accounts/:accountId/campaigns/:campaignId?'

export const reportsInsightsPath = '/accounts/:accountId/reports/insights'

export const reportsPerformancePath = '/accounts/:accountId/reports/performance'
export const reportsPath = '/accounts/:accountId/reports'
export const accountsPath = '/accounts'
export const dashboardPath = '/dashboard'
export const homePath = '/home'
export const profilePath = '/profile'
export const adminPath = '/admin'
export const contentPath = '/content'
export const demoPath = '/demo'
export const personalizationPath = '/personalization'

export const adminLanguagePath = '/admin/language'
